import React, { useEffect, useState } from 'react';

export default function Tv24CurationTab(props) {
  const [data, setData] = useState(null);

  useEffect(() => {
    if (props.data) {
      const filtered = filterAndExtractFirst(props.data)
      setData(filtered);
    }    
  }, [props]);

  const filterAndExtractFirst = (data) => {
    const result = [];
    let editorPickIncluded = false;

    data.forEach(item => {
      if (!item.category || item.category !== 'NEW & HOT') {
        if (item.category === 'PICK') {
          if (!editorPickIncluded) {
            result.push(item);
            editorPickIncluded = true;
          }
        } else {
          result.push(item);
        }
      }
    });
    return result;
  };

  const clickHandler = () => {
    const tabs = document.querySelectorAll('.tab_list_inner');
    tabs.forEach((element) => {
      element.addEventListener('click', (event) => {
        tabs.forEach((tab) => tab.classList.remove('current'));
        element.classList.add('current');
      }, false);
    });
  }


  return (
    <div className="tablist_w_24tv">
      {data && data.map((item, index) => {
        let itemTitle = item.category ? item.category : item.title;
        return (
          <a
            key={index}
            className={index === 0 ? "tab_list_inner current" : "tab_list_inner"}
            href={"#" + encodeURIComponent(itemTitle.trim())}
            onClick={clickHandler}
          >
            <span className="tab_list_text">{itemTitle}</span>
          </a>
        );
      })}
    </div>
  );
}
